import React, {useEffect, useState} from "react";
import {FaPen, FaPlus} from "react-icons/fa";
import Button from "../../../../../components/button/button.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";

const ObservationCellRenderer = ({data, setCautions, label, setOpenModalObservation}) => {
    const {id, is_caution, observation} = data;
    const [openModal, setOpenModal] = useState(false)
    const [dataObservation, setData] = useState(observation)

    useEffect(() => {
        setOpenModalObservation(openModal)
    }, [openModal]);

    const add = () => {
        setCautions(prev => prev.map(m => m.id === id ? ({...m, observation: dataObservation}) : m))

        setOpenModal(true)
    }

    return (
        <>
            <div className={"flex items-center justify-center h-full"}>
                <Button disabled={!is_caution} className={"h-6.25!"} onClick={() => setOpenModal(true)} title={`Adicionar ${label}`}>
                    {observation && <FaPen />}
                    {!observation && <FaPlus />}
                </Button>
            </div>

            <Modal alignTop={true} open={openModal} setOpen={setOpenModal} overflow={true} size="md" backdrop="static" keyboard={false} title={label} className={"w-4/12"}>
                <Modal.Body className={"p-2 grid grid-cols-12 gap-3"}>
                    <InputTextarea
                        id={"final-observation"}
                        className={"col-span-12"}
                        textAreaClass={"h-40"}
                        label={label}
                        value={dataObservation}
                        onChange={(e) => setData(e.target.value)}
                    />
                </Modal.Body>
                <Modal.Footer className={"p-1"}>
                    <div className="w-full flex justify-end gap-3 m-0">
                        <Button target="primary" onClick={add}>Confirmar</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ObservationCellRenderer